import { render, staticRenderFns } from "./slaccountcash-add-or-update.vue?vue&type=template&id=51cd4c3c&"
import script from "./slaccountcash-add-or-update.vue?vue&type=script&lang=js&"
export * from "./slaccountcash-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports